import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query"
import axios from "axios";
import { apiRoot, SetUserContext, getUserFromDbUser } from "..";

const Login = () => {
  const setUser = useContext(SetUserContext);
  const navigate = useNavigate();

  const [inputs, setInputs] = useState({});
  const [errorMessage, setErrorMessage] = useState(null);

  const loginMutation = useMutation((loginData) => {
    return axios.post(apiRoot + '/login', loginData);
  },
  {
    onSuccess: (response) => {
      const jwtToken = response.data.token;
      window.sessionStorage.setItem('jwtToken', jwtToken);
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken; // TODO
      setUser(getUserFromDbUser(response.data.user));
      navigate("/aktuality");
    },
    onError: (error) => {
      setErrorMessage(error.message); // TODO json -> errorCode -> hlaska
      window.scrollTo(0, 0);
    }
  });

  const handleChange = (event) => {
    if (!loginMutation.isLoading) {
      const name = event.target.name;
      const value = event.target.value;
      setInputs(values => ({...values, [name]: value}))
    }
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    setErrorMessage(null);

    if (!inputs.mail || !inputs.passwd) { // TODO trim
      setErrorMessage('Některé povinné položky nejsou vyplněné.');
      window.scrollTo(0, 0);
      // TODO zvyrazneni nevyplnenych vstupnich poli
      return;
    }

    loginMutation.mutate(inputs);
  }

  return (
    <>
<div className="login-wrapper">
<div className="login">
<form onSubmit={handleSubmit}>
<table border="0" cellSpacing="0">
  <tbody>
    <tr>
      <td align="center">{errorMessage && <div className="alert alert-danger" role="alert">{errorMessage}</div>}</td>
    </tr> 
    <tr>  
      <td align="center"><img src="img/padlock.png" alt="Přihlášení" width="64" height="64" /></td>
    </tr>
    <tr>
      <td>&nbsp;</td>
    </tr>
    <tr>
      <td align="center"><strong>Přihlašovací jméno (e-mail):</strong></td>
    </tr> 
    <tr>
      <td align="center"><input type="text" className="form-control" name="mail" value={inputs.mail || ""} onChange={handleChange} /></td>
    </tr>
    <tr>
      <td align="center"><strong>Heslo:</strong></td>
    </tr>
    <tr> 
      <td align="center"><input type="password" className="form-control" name="passwd" value={inputs.passwd || ""} onChange={handleChange} /></td>
    </tr>
    <tr>
      <td>&nbsp;</td>
    </tr>
    <tr>
      <td align="center"><button type="submit" className="btn btn-primary">Přihlásit</button></td>
    </tr>
    <tr>
      <td>&nbsp;</td>
    </tr>
    <tr>
      <td align="center"><a href="/passwd_reset_request.php">Zapomněli&nbsp;jste&nbsp;heslo?</a> | <strong><a href="/user_registration_request.php">Chcete&nbsp;se&nbsp;zaregistrovat?</a></strong></td>
    </tr>
  </tbody>
</table>

</form>
</div>
</div>

<div className="login-image">
&nbsp;
</div>
    </>
  );
};

export default Login;